{
  "version": 1,
  "asset_id": "246b31f6-6ca1-444a-b7a6-d9222634c3a0",
  "project_id": "b6523e41-24b0-43cb-a6b6-94aaf0ff838d",
  "url": "/__l5e/assets-v1/246b31f6-6ca1-444a-b7a6-d9222634c3a0/generators-banner.png",
  "r2_key": "a/v1/b6523e41-24b0-43cb-a6b6-94aaf0ff838d/246b31f6-6ca1-444a-b7a6-d9222634c3a0/generators-banner.png",
  "original_filename": "generators-banner.png",
  "size": 1338986,
  "content_type": "image/png",
  "created_at": "2026-06-05T12:30:32Z"
}
